/**
 * @file ReportEvents.ts
 * @description 设备主动上报事件名称。
 * 设备族 report 解析后应尽量使用集中事件名，降低字符串拼写风险。
 */

export const ReportEvents = {
  Raw: 'report',
  Battery: 'report:Battery_changed',
  CfgChanged: 'report:Cfg_changed',
  /** 键盘用户自定义数据上报 */
  KeyUserData: 'report:Key_user_data',
  /** 键盘校准上传 */
  KeyCalibUpload: 'report:Key_calib_upload',
  /** 键盘 RT 切换上报 */
  KeyRtSwitch: 'report:Key_rt_switch',
  /** 鼠标用户自定义数据上报 */
  MouseUserData: 'report:Mouse_user_data',
  /** 鼠标 DPI 档位切换上报 */
  DpiGearChanged: 'report:Dpi_Gear_changed',
  /** 鼠标回报率变更上报 */
  ReportRateChanged: 'report:ReportRate_Changed',
  /** 鼠标按键扫描率变更上报 */
  ScanRateChanged: 'report:ScanRate_Changed',
  /** 键盘背光亮度变更上报 */
  BrightnessChanged: 'report:Brightness_changed',
  /** 键盘背光速度变更上报 */
  SpeedChanged: 'report:Speed_changed',
  /** 键盘背光灯效变更上报（按 FN 灯效切换键等硬件侧操作触发），payload 为 blMode */
  EffectChanged: 'report:Effect_changed',
  /** 键盘系统模式变更上报（Win/Mac），payload 为 sysMode：0=win，1=mac */
  SysModeChanged: 'report:SysMode_changed',
} as const

export type ReportEventName = (typeof ReportEvents)[keyof typeof ReportEvents]

/** 设备用户数据上报事件列表，用于同步设备状态到各窗口 */
export const UserDataSyncEvents: readonly string[] = [
  ReportEvents.KeyUserData,
  ReportEvents.MouseUserData,
  ReportEvents.CfgChanged,
]
